import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { apiRequest } from "../api/apiClient.js";
import type { SearchResultDTO, SearchSortDTO } from "../api/types.js";

export interface SearchRequest {
  query: string;
  source: string;
  type: string;
  sort: SearchSortDTO;
  offset: number;
}

export function searchPath(request: SearchRequest): string {
  const params = new URLSearchParams({ q: request.query, sort: request.sort, offset: String(request.offset), limit: "20" });
  if (request.source) params.append("source", request.source);
  if (request.type) params.append("type", request.type);
  return `/search?${params}`;
}

export function useGlobalSearch(request: SearchRequest): UseQueryResult<SearchResultDTO, Error> {
  const normalized = request.query.trim();
  return useQuery({
    queryKey: ["search", normalized, request.source, request.type, request.sort, request.offset],
    queryFn: () => apiRequest<SearchResultDTO>(searchPath({ ...request, query: normalized })),
    enabled: normalized.length >= 2,
    placeholderData: (previous) => previous,
  });
}
